import { TASK_STATUSES } from '@k-os/core';
import { usePatchTask, type TaskDto } from '../../api/tasks';
import { PickerList } from './_picker-primitives';

const STATUS_LABELS: Record<TaskDto['status'], string> = {
  inbox: 'Inbox',
  next: 'Next',
  scheduled: 'Scheduled',
  waiting: 'Waiting',
  delegated: 'Delegated',
  blocked: 'Blocked',
  someday: 'Someday',
  done: 'Done',
};

export function StatusEditor({ task, onClose }: { task: TaskDto; onClose: () => void }) {
  const patch = usePatchTask();
  return (
    <PickerList
      options={TASK_STATUSES.map((s) => ({ id: s, label: STATUS_LABELS[s] }))}
      activeId={task.status}
      onPick={(id) => {
        patch.mutate({ id: task.id, patch: { status: id as TaskDto['status'] } });
        onClose();
      }}
    />
  );
}
export { STATUS_LABELS };
